import React, { useContext, useEffect, useState } from "react";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import styles from "./Step.module.css";
import { PatchApi, PostApi, getApi } from "../../../Utility/network";
import { useLocation, useNavigate } from "react-router-dom";
import CustomCheckBoxService from "../../../Components/CustomCheckBoxService/CustomCheckBoxService";
import info from "../../../assets/componentAssets/info.svg";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import {
  validateEmail,
  validateGermanPhoneNumber,
  validateGermanVAT,
  validatePostalCode,
} from "../utility/validations";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import billing from "../../../assets/componentAssets/billing.svg";
import { selectedLanguage } from "../../../Utility/helper";
import { consumCertEngText } from "../../../Utility/engLangObject";
import { consumCertGerText } from "../../../Utility/gerLangObject";
import { checkIfvalueExists } from "../utility/utils";

function Step8({ showForm = false, props }) {
  const location = useLocation();
  const [isCertificate, setIsCertificate] = useState(false);
  useEffect(() => {
    const isConsumptionCertificate = location.pathname.includes("/form/");
    setIsCertificate(isConsumptionCertificate);
  }, [location]);
  const style = { width: "100%" };
  const navigate = useNavigate();
  const [showPop, setShowPop] = useState(false);
  const [breakdown, setBreakDown] = useState({
    sub_total: null,
    total: null,
    add_on_service: [],
  });
  const [checked, setChecked] = useState({ check: false });
  const { state, setState } = useContext(AppContext);
  const { info: info1, add_Services } = state.otherData;
  const { stepLanguage, language } = state;
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState([]);
  const [services, setServices] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedPackageIds, setSelectedPackageIds] = useState([]);
  const [pop, setPop] = useState(false);
  const [infoText, setInfoText] = useState([]);
  const [response, setResponse] = useState(false);
  const [checkInputs, setCheckInputs] = useState(false);
  const [loader, setLoader] = useState(false);
  const [url, setUrl] = useState("");
  const [data, setData] = useState({
    order_type: 1,
    first_name: "",
    last_name: "",
    phone: null,
    postcode: null,
    location: "",
    email: "",
    company_name: "",
    vat_id: "",
    street: "",
  });

  const getPackageIdsFromReviewData = (reviewData) => {
    if (!reviewData) return [];

    try {
      const parsed =
        typeof reviewData === "string" ? JSON.parse(reviewData) : reviewData;
      if (!Array.isArray(parsed?.selected_packages)) {
        return [];
      }

      return parsed.selected_packages
        .map((pkg) => Number(pkg))
        .filter((pkg) => !Number.isNaN(pkg));
    } catch (error) {
      console.error("Error parsing package review data:", error);
      return [];
    }
  };

  const getPackageIdsFromAdditionalInfoList = (list) => {
    if (!Array.isArray(list)) return [];

    for (const item of list) {
      const packageIds = getPackageIdsFromReviewData(item?.review_data);
      if (packageIds.length > 0) {
        return packageIds;
      }
    }

    return [];
  };
  useEffect(() => {
    getServices();
    getPackages();
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    if (!state?.form_id) return;
    getbreakDown();
    getConsumptionDetails();
  }, [state?.form_id]);
  useEffect(() => {
    const service_id = add_Services.map((item) => item.service?.id);
    setSelected(service_id);
  }, [add_Services]);
  useEffect(() => {
    checkIfvalueExists();
  }, [data]);
  useEffect(() => {
    const { lastStep, buildingData } = state.otherData;
    console.log(state, "lastStep");

    if (lastStep) {
      setData((prev) => {
        const { postcode, street, location, email } = prev;
        let post = postcode
          ? postcode
          : lastStep?.postcode
            ? lastStep?.postcode
            : info1?.postcode;
        let loc = location
          ? location
          : lastStep?.location
            ? lastStep?.location
            : info1?.location;
        let streetHouse = street
          ? street
          : lastStep?.street
            ? lastStep?.street
            : info1?.street;
        let emailId = email
          ? email
          : lastStep?.email
            ? lastStep?.email
            : buildingData?.email;

        return {
          ...lastStep,
          postcode: post,
          location: loc,
          street: streetHouse,
          email: emailId,
          company_name: lastStep.company_name,
          vat_id: lastStep.vat_id,
          first_name: lastStep.first_name,
          last_name: lastStep.last_name,
        };
      });
    }
  }, [state.otherData]);

  const getServices = async () => {
    try {
      const responseData = await getApi(`energy_consumption/add_on_services`);
      let data = responseData?.data;
      if (data?.data) data = data.data;
      else if (data?.results) data = data.results;

      if (Array.isArray(data)) {
        setServices(data);
      }
    } catch (error) { }
  };

  const getPackages = async () => {
    try {
      const responseData = await getApi(`payment/packages/`);

      let data = responseData.data;
      if (data && data.results) {
        data = data.results;
      } else if (data && data.data) {
        // Handle potential wrapper like { data: [...] }
        data = data.data;
      }

      const mappedData = (Array.isArray(data) ? data : []).map(pkg => ({
        ...pkg,
        amount: pkg.total_price // Map total_price to amount for CustomCheckBoxService
      }));
      setPackages(mappedData);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  const getConsumptionDetails = async () => {
    try {
      if (state.form_id) {
        const responseData = await getApi(`energy_consumption/form/${state.form_id}/`);
        if (responseData.status === 200) {
          const packages = responseData?.data?.data?.certificate_packages || [];
          const packageIds = packages
            .map((pkg) => Number(pkg.id || pkg))
            .filter((pkg) => !Number.isNaN(pkg));

          if (packageIds.length > 0) {
            setSelectedPackageIds(packageIds);
            return;
          }
        }

        const additionalInfoResponse = await getApi(
          `/energy_consumption/additional_information?energy_consumption=${state.form_id}`
        );
        const list =
          additionalInfoResponse?.data?.data || additionalInfoResponse?.data || [];
        const fallbackPackageIds = getPackageIdsFromAdditionalInfoList(list);
        setSelectedPackageIds(fallbackPackageIds);
      }
    } catch (error) {
      console.error("Error fetching consumption details:", error);
    }
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    const error = validateFields(name, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));

    setData((prev) => ({ ...prev, [name]: value }));
  };
  const validateFields = (name, value) => {
    let error = "";
    const fieldName = "";
    // formStep1.find((field) => field.name === name)?.title || name;
    switch (name) {
      case "email":
        error = validateEmail(value, stepLanguage);
        break;
      case "postcode":
        error = validatePostalCode(value, stepLanguage);
        break;
      case "first_name":
      case "last_name":
      case "company_name":
      case "location":
      case "street":
        error = validateRequiredField(value, fieldName, "");
        break;
      case "phone":
        error = validateGermanPhoneNumber(value, stepLanguage.not_valid_num);
        break;
      case "vat_id":
        error = validateGermanVAT(value);
        break;
      default:
        break;
    }
    return error;
  };

  const validateRequiredField = (value, fieldName, type) => {
    if (type === "phone") {
      if (!value) {
        return `The ${fieldName} is required as a number.`;
      }
      if (/[-eE+]/.test(value)) {
        return `${fieldName} should not contain '-', 'e', or '+'.`;
      }
      return "";
    } else {
      return value ? "" : stepLanguage.field_required;
    }
  };

  const handleSubmit = async (num, type) => {
    try {
      if (type === "next") {
        try {
          const order_type = data.order_type;
          const { company_name, vat_id, ...rest } = data;
          let newData = { ...rest };
          const { company_name: company, vat_id: vat, ...rests } = errors;
          let newError = { ...rests };
          if (order_type == 2) {
            newData = { ...newData, company_name, vat_id };
            newError = { ...newError, company_name: company, vat: vat_id };
          } else if (order_type == 3) {
            newData = { ...newData, company_name };
            newError = { ...newError, company_name: company };
          }

          const validateFields = (object) => {
            const errors = {};
            Object.keys(object).forEach((key) => {
              const value = object[key];
              // Check if the value is either an empty string or null
              if (value === "" || value === null) {
                errors[key] = `this field cannot be empty.`;
              }
            });
            return errors;
          };
          const errorss = validateFields(newData);
          if (Object.keys(errorss).length === 0) {
          } else {
            setErrors(errorss);
            return;
          }
          const postData = await PatchApi(
            `/energy_consumption/form/${state.form_id}/`,
            { billing_address: newData }
          );
          if (postData.status === 200 || postData.status === 201) {
            const postEnergy = await getApi(
              `energy_consumption/form/${state.form_id}/calculate_energy_consumption/`
            );
            const payData = await PostApi(`/payment/checkout/`, {
              energy_consumption_id: state.form_id,
            });
            localStorage.setItem("purchase_id", payData.data.data.id);

            window.open(payData.data.data.gateway_url, "_blank").focus();
            setState((prev) => ({
              ...prev,
              otherData: {
                hotwater_included_in_heating_system: 0,
                construction_year: null,
                heating_info: [],
                yearArray: [],
                buildingData: {},
                buildingData: {},
                vacancy: [],
                noOfHeatingSystem: null,
                property: null,
                delAdd: null,
                info: {},
              },
              form_id: null,
              page: 1,
              filledPage: 1,
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "prev") {
        setState((prev) => ({
          ...prev,
          page: prev.page - 1,
          otherData: { ...prev.otherData, lastStep: data },
        }));
      } else if (type === "save") {
        await getApi(`/energy_consumption/form/${state.form_id}/generate_link`);
        // navigate("/login");
      } else if (type === "submit-save") {
        try {
          const order_type = data.order_type;
          const { company_name, vat_id, ...rest } = data;
          let newData = { ...rest };
          const { company_name: company, vat_id: vat, ...rests } = errors;
          let newError = { ...rests };
          if (order_type == 2) {
            newData = { ...newData, company_name, vat_id };
            newError = { ...newError, company_name: company, vat: vat_id };
          } else if (order_type == 3) {
            newData = { ...newData, company_name };
            newError = { ...newError, company_name: company };
          }

          const validateFields = (object) => {
            const errors = {};
            Object.keys(object).forEach((key) => {
              const value = object[key];
              // Check if the value is either an empty string or null
              if (value === "" || value === null) {
                errors[key] = `this field cannot be empty.`;
              }
            });
            return errors;
          };
          const errorss = validateFields(newData);
          if (Object.keys(errorss).length === 0) {
          } else {
            setErrors(errorss);
            return;
          }
          const postData = await PatchApi(
            `/energy_consumption/form/${state.form_id}/`,
            { billing_address: newData }
          );
          if (postData.status === 200 || postData.status === 201) {
            setShowPop(true);
          }
        } catch (error) {
          alert("something went wrong");
        }
      }
    } catch (error) {
      alert("something went wrong");
    }
  };
  const getbreakDown = async () => {
    try {
      const responseData = await getApi(
        `energy_consumption/form/${state.form_id}/breakdown`
      );
      setBreakDown(responseData.data.data);
    } catch (error) { }
  };

  const handleCheckboxChange = async (checkedIds) => {
    // if (name === "ventilation_id") {
    //   setSubmitData((prev) => ({ ...prev, ventilation_id: checkedIds }));
    // }
    setSelected(checkedIds);
    const data = {
      service_id: checkedIds,
    };
    try {
      const responseData = await PatchApi(
        `energy_consumption/form/${state.form_id}/add_on_services/`,
        data
      );
      if (
        responseData.status === 200 ||
        responseData.status === 201 ||
        responseData.status === 204
      ) {
        getbreakDown();
      }
    } catch (error) { }
  };
  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const popData = {
    number: [
      {
        heading: stepLanguage.number_h,
        para1: stepLanguage.address_d1,
        para2: stepLanguage.address_d2,
        para3: stepLanguage.address_d3,
      },
    ],
    Postcode: [
      {
        heading: stepLanguage.Postcode_h,
        para1: stepLanguage.address_d1,
        para2: stepLanguage.address_d2,
        para3: stepLanguage.address_d3,
      },
    ],
    Location: [
      {
        heading: stepLanguage.Location_h,
        para1: stepLanguage.address_d1,
        para2: stepLanguage.address_d2,
        para3: stepLanguage.address_d3,
      },
    ],
    order: [
      {
        heading: stepLanguage.order_h,
        para1: stepLanguage.order_d,
      },
    ],
    email: [
      {
        heading: stepLanguage.email,
        para1: stepLanguage.e_para_1,
        para2: stepLanguage.e_para_2,
      },
    ],
  };
  const handlePackageChange = async (checkedIds) => {
    setSelectedPackageIds(checkedIds);
    const data = {
      certificate_packages: checkedIds,
    };
    try {
      const responseData = await PatchApi(
        `energy_consumption/form/${state.form_id}/`,
        data
      );
      if (
        responseData.status === 200 ||
        responseData.status === 201 ||
        responseData.status === 204
      ) {
        getbreakDown();
      }
    } catch (error) { }
  };

  const consumptionLanguage = language === "en" ? consumCertEngText : consumCertGerText;

  return (
    <>
      <div
        style={{
          marginTop: "40px",
          boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.24)",
          borderRadius: "12px",
        }}
      >
        <StepsHeader
          image={billing}
          heading={state?.headerLanguage?.billing_delivery_address}
          secPara={stepLanguage.Please_provide_proper_information}
        />
        <div className={styles.billingCon}>
          <div className={styles.order} style={{ marginBottom: "40px" }}>
            <div className={styles.fieldCom}>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {stepLanguage.order_type}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.order)}
                  />
                </p>
                <FormControl>
                  <RadioGroup
                    name="order_type" // Name of the radio group
                    value={data.order_type} // Bind the state value
                    onChange={handleChange} // Handle value changes
                  >
                    <div className={styles.Radio1}>
                      {orderType.map((item, index) => {
                        return (
                          <FormControlLabel
                            value={item.id}
                            control={<Radio />}
                            label={selectedLanguage(item, language)}
                          />
                        );
                      })}
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>{stepLanguage.phone_number}</p>
                <TextField
                  style={style}
                  size="small"
                  name="phone"
                  value={data.phone}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange} // Handle value changes
                  type="number"
                  error={errors?.phone}
                  helperText={errors?.phone}
                />
              </div>
              {data.order_type != 1 && (
                <React.Fragment>
                  <div
                    className={styles.fields}
                    style={{
                      width: `${data.order_type == 3 ? "100%" : "48%"}`,
                    }}
                  >
                    <p className={styles.fieldName}>
                      {stepLanguage.company_name}
                    </p>
                    <TextField
                      size="small"
                      style={style}
                      onWheel={(e) => e.target.blur()}
                      value={data.company_name}
                      name="company_name"
                      onChange={handleChange} // Handle value changes
                      error={errors?.company_name}
                      helperText={errors?.company_name}
                    />
                  </div>
                  {data.order_type == 2 && (
                    <div className={styles.fields}>
                      <p className={styles.fieldName}>{stepLanguage.vat_id}</p>
                      <TextField
                        size="small"
                        style={style}
                        onWheel={(e) => e.target.blur()}
                        value={data.vat_id}
                        name="vat_id"
                        onChange={handleChange} // Handle value changes
                        error={errors?.vat_id}
                        helperText={errors?.vat_id}
                      />
                    </div>
                  )}
                </React.Fragment>
              )}
              <div className={styles.fields}>
                <p className={styles.fieldName}>{stepLanguage.first_name}</p>
                <TextField
                  size="small"
                  style={style}
                  value={data.first_name}
                  onWheel={(e) => e.target.blur()}
                  name="first_name"
                  onChange={handleChange} // Handle value changes
                  error={errors?.first_name}
                  helperText={errors?.first_name}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>{stepLanguage.surname}</p>
                <TextField
                  size="small"
                  style={style}
                  name="last_name"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange} // Handle value changes
                  value={data.last_name}
                  error={errors?.last_name}
                  helperText={errors?.last_name}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {stepLanguage.billing_house_number}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.number)}
                  />
                </p>
                <TextField
                  size="small"
                  style={style}
                  name="street"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange} // Handle value changes
                  value={data.street}
                  error={errors?.street}
                  helperText={errors?.street}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {stepLanguage.postcode}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.Postcode)}
                  />
                </p>
                <TextField
                  size="small"
                  style={style}
                  name="postcode"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange} // Handle value changes
                  value={data.postcode}
                  error={errors?.postcode}
                  helperText={errors?.postcode}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {stepLanguage.location}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.Location)}
                  />
                </p>
                <TextField
                  size="small"
                  style={style}
                  onWheel={(e) => e.target.blur()}
                  name="location"
                  onChange={handleChange} // Handle value changes
                  value={data.location}
                  error={errors?.location}
                  helperText={errors?.location}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {stepLanguage.eMail}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.email)}
                  />
                </p>
                <TextField
                  size="small"
                  style={style}
                  name="email"
                  onChange={handleChange} // Handle value changes
                  value={data.email}
                  error={errors?.email}
                  onWheel={(e) => e.target.blur()}
                  helperText={errors?.email}
                />
              </div>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h3>{consumptionLanguage.certificate_packages_title}</h3>
              <p>{consumptionLanguage.certificate_packages_description}</p>
              {(packages && packages.length > 0) ? (
                <CustomCheckBoxService
                  data={packages}
                  name="certificate_packages"
                  onCheckChange={handlePackageChange}
                  selectedValues={selectedPackageIds}
                />
              ) : (
                <p style={{ color: '#888' }}>No packages available</p>
              )}
            </div>

            <div style={{ marginBottom: "20px" }}>
              <h3>{stepLanguage.add_on_services}</h3>
              <CustomCheckBoxService
                data={services}
                name="service_id"
                onCheckChange={handleCheckboxChange}
                selectedValues={selected}
              />
            </div>
          </div>
          {isCertificate && (
            <div className={styles.summary}>
              <div style={{ borderBottom: "1px solid #22A156" }}>
                <p
                  style={{
                    color: "#22A156",
                    fontWeight: "900",
                    fontSize: "22px",
                    textAlign: "center",
                  }}
                >
                  {stepLanguage.order_summary}
                </p>
              </div>
              <div style={{ borderBottom: "1px solid #22A156" }}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ width: "80%" }}>
                    <p
                      style={{
                        marginBottom: "5px",
                        fontWeight: "900",
                        fontSize: "16px",
                      }}
                    >
                      <b>{stepLanguage.energy_performance_text}</b>
                    </p>
                    <p
                      style={{
                        marginTop: "8px",
                        marginBottom: "8px",
                        fontSize: "14px",
                      }}
                    >
                      {stepLanguage.consum_residential_buildings}
                    </p>
                  </div>
                  <p
                    style={{
                      marginBottom: "5px",
                      fontWeight: "900",
                      fontSize: "16px",
                    }}
                  >
                    {breakdown.sub_total} &#8364;
                  </p>
                </div>
              </div>
              {breakdown.add_on_service.map((item, index) => {
                return (
                  <div style={{ borderBottom: "1px solid #22A156" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "80%" }}>
                        <p
                          style={{
                            marginBottom: "5px",
                            fontSize: "16px",
                            fontWeight: "900",
                          }}
                        >
                          <b>{selectedLanguage(item)}</b>
                        </p>
                        {/* <p
                      style={{
                        marginTop: "8px",
                        marginBottom: "8px",
                        fontSize: "14px",
                      }}
                    >
                      Consumption Certificate for Residential Buildings
                    </p> */}
                      </div>
                      <p
                        style={{
                          marginBottom: "5px",
                          fontWeight: "900",
                          fontSize: "16px",
                        }}
                      >
                        {item.amount} &#8364;
                      </p>
                    </div>
                  </div>
                );
              })}
              <div
                style={{
                  borderBottom: "1px solid #22A156",
                  margin: "10px 0px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                    border: "1px solid #22a156",
                    padding: "8px",
                    borderRadius: "5px",
                    boxShadow:
                      "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
                  }}
                >
                  <div style={{ width: "30px" }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checked.check} // Reflect selected values
                            onChange={async () => {
                              const order_type = data.order_type;
                              const { company_name, vat_id, ...rest } = data;
                              let newData = { ...rest };
                              const {
                                company_name: company,
                                vat_id: vat,
                                ...rests
                              } = errors;
                              let newError = { ...rests };
                              if (order_type == 2) {
                                newData = { ...newData, company_name, vat_id };
                                newError = {
                                  ...newError,
                                  company_name: company,
                                  vat: vat_id,
                                };
                              } else if (order_type == 3) {
                                newData = { ...newData, company_name };
                                newError = {
                                  ...newError,
                                  company_name: company,
                                };
                              }

                              const validateFields = (object) => {
                                const errors = {};
                                Object.keys(object).forEach((key) => {
                                  const value = object[key];
                                  // Check if the value is either an empty string or null
                                  if (value === "" || value === null) {
                                    errors[key] = stepLanguage.cannot_be_empty;
                                  }
                                });
                                // if (checked.check === false) {
                                //   errors.check = stepLanguage.proceed;
                                // }
                                return errors;
                              };
                              const errorss = validateFields(newData);
                              if (Object.keys(errorss).length === 0) {
                                setChecked((prev) => ({ check: !prev.check }));
                                setLoader(true);
                                try {
                                  const postData = await PatchApi(
                                    `/energy_consumption/form/${state.form_id}/`,
                                    { billing_address: newData }
                                  );
                                  if (
                                    postData.status === 200 ||
                                    postData.status === 201
                                  ) {
                                    const postEnergy = await getApi(
                                      `energy_consumption/form/${state.form_id}/calculate_energy_consumption/`
                                    );

                                    // const addOnService = await PatchApi(
                                    //   `energy_consumption/form/${state?.form_id}/add_on_services/`,
                                    //   {
                                    //     service_id: selected,
                                    //   }
                                    // );
                                    const payData = await PostApi(
                                      `/payment/checkout/`,
                                      {
                                        energy_consumption_id: state.form_id,
                                      }
                                    );
                                    setLoader(false);
                                    setUrl(payData.data.data.gateway_url);
                                    localStorage.setItem(
                                      "purchase_id",
                                      payData.data.data.id
                                    );
                                  }
                                } catch (error) {
                                  setChecked((prev) => ({ check: false }));
                                }
                              } else {
                                setErrors(errorss);
                                return;
                              }
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                  <div>
                    <p
                      style={{
                        margin: "0px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        marginBottom: "5px",
                      }}
                    >
                      {stepLanguage.i_agree_text}
                    </p>{" "}
                    <p
                      style={{
                        margin: "5px 0px",
                        fontSize: "14px ",
                        color: "#d32f2f",
                      }}
                    >
                      {errors.check}
                    </p>
                    <a
                      style={{
                        margin: "0px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        textDecoration: "underline",
                        color: "#22A156",
                      }}
                      href="https://greenox-group.de/agb-energieausweis/"
                      target="_blank"
                    // className={styles.terms}
                    >
                      {stepLanguage.terms_conditions}
                    </a>
                    <br />
                    <a
                      style={{
                        margin: "0px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        textDecoration: "underline",
                        color: "#22A156",
                      }}
                      href="https://greenox-group.de/datenschutz/"
                      target="_blank"
                    // className={styles.terms}
                    >
                      {stepLanguage.privacy_policy}
                    </a>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #22A156",
                }}
              >
                <p style={{ fontWeight: "900" }}>{stepLanguage.total}</p>
                <div>
                  <p style={{ marginBottom: "4px", textAlign: "right" }}>
                    <b>{breakdown.total} &#8364;</b>
                  </p>
                  <p style={{ margin: "4px 0px" }}>
                    ({stepLanguage.including})
                  </p>
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <Button
                  style={{ marginTop: "10px", width: "100%" }}
                  variant="contained"
                  onClick={() => {
                    const validateFields = () => {
                      const errors = {};
                      if (checked.check === false) {
                        errors.check = stepLanguage.proceed;
                      }
                      return errors;
                    };
                    const errorss = validateFields();
                    if (Object.keys(errorss).length === 0) {
                    } else {
                      setErrors(errorss);
                      return;
                    }
                    setState((prev) => ({
                      ...prev,
                      otherData: {
                        hotwater_included_in_heating_system: 0,
                        construction_year: null,
                        heating_info: [],
                        yearArray: [],
                        buildingData: {},
                        buildingData: {},
                        vacancy: [],
                        noOfHeatingSystem: null,
                        property: null,
                        delAdd: null,
                        info: {},
                      },
                      form_id: null,
                      page: 1,
                      filledPage: 1,
                    }));
                    window.open(url, "_self").focus();
                  }}
                  sx={{
                    padding: "12px 25px",
                    fontWeight: "900",
                    borderRadius: "10px",
                    background:
                      " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                    boxShadow: "none",
                    color: "white",
                    "&:disabled": {
                      background: "gray",
                      color: "#ccc",
                    },
                  }}
                  disabled={loader}
                >
                  {loader && (
                    <CircularProgress
                      size={25}
                      style={{ marginRight: "20px" }}
                    />
                  )}{" "}
                  {stepLanguage.order_now}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        show={false}
        showPrint={!isCertificate}
        showPop={showPop}
      />
      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </>
  );
}

export default Step8;

const object = {
  billing_address: {
    order_type: 1,
    first_name: "dsd",
    last_name: "dsd",
    phone: "9146917230",
    email: "kiratwad@gmail.com",
    postcode: "12345",
    street: "sa",
    location: "sas",
  },
};

const orderType = [
  {
    title: consumCertEngText.private_owners,
    german_title: consumCertGerText.private_owners,
    id: 1,
  },
  {
    title: consumCertEngText.commercial,
    german_title: consumCertGerText.commercial,
    id: 2,
  },
  {
    title: consumCertEngText.commercial_ustId,
    german_title: consumCertGerText.commercial_ustId,
    id: 3,
  },
];
